import { IBillPackage } from '@/@types/bill-package'
import { create } from 'zustand'

type BillPackageStore = {
  billPackage: IBillPackage | null
  setPackage: (billPackage?: IBillPackage) => void
  clearPackage: () => void
}

export const useBillPackageStore = create<BillPackageStore>((set) => ({
  billPackage: null,
  setPackage: (billPackage) => set({ billPackage }),
  clearPackage: () => set({ billPackage: null }),
}))
